import UploadImage from "../UploadImage";
import { useState } from "react";
import validation from "../../../Validations/AddFrame";
import Titel from "../Titel";
import InputField from "../InputField";

import useAxios from '../../../hooks/useAxios';
const NewFrame = () => {
    const { AxiosPrivate } = useAxios()
    const [data, setData] = useState({ images: [], full_frame: [], horizontal_frame: [], vertical_frame: [], title: '', body: '' })
    const [loading, setLoading] = useState(false)
    const [touch, setTouch] = useState({})
    const errors = validation(data)

    const handleChange = (e) => {
        const { name } = e.target
        const { value } = e.target
        setData(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (Object.keys(errors).length) {
            setTouch({ title: true, images: true, full_frame: true, horizontal_frame: true, vertical_frame: true, width: true, pixel_width: true, price: true, body: true })
        } else {
            await AxiosPrivate.post('/frame/store', data, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: () => {
                    setLoading(true)
                },
            })
                .then(res => {
                    setData({ images: [], full_frame: [], horizontal_frame: [], vertical_frame: [], title: '', body: '', price: '', width: '', pixel_width: '' })
                    alert(res.data.message);
                    setLoading(false)
                })
                .catch(err => { alert(err.response?.data.message || 'مشکلی پیش آمده'); setLoading(false) })
        }
    }
    return (
        <>
            <div className="max-w-xl w-full mx-auto my-4">
                <Titel title="افزودن قاب" className="md:text-xl" />
                <form className="flex flex-col items-center" onSubmit={handleSubmit}>
                    <div className="flex flex-wrap items-center justify-between mt-6 gap-x-1">
                        <div className="relative pb-6 mb-4 max-w-[49%] w-full">
                            <UploadImage setData={setData} errors={errors} touch={touch} label='عکس مربع' name='full_frame' images={data.full_frame} />
                        </div>
                        <div className="relative pb-6 mb-4 max-w-[49%] w-full">
                            <UploadImage setData={setData} errors={errors} touch={touch} label='عکس گوشه' name='images' images={data.images} />
                        </div>
                        <div className="relative pb-6 mb-4 max-w-[49%] w-full">
                            <UploadImage setData={setData} errors={errors} touch={touch} label='عکس عمودی' name='vertical_frame' images={data.vertical_frame} />
                        </div>
                        <div className="relative pb-6 mb-4 max-w-[49%] w-full">
                            <UploadImage setData={setData} errors={errors} touch={touch} label='عکس افقی' name='horizontal_frame' images={data.horizontal_frame} />
                        </div>
                        <InputField label={'عنوان'} id={5} max_width={'100%'} name={'title'} type={'text'} {...{ data, touch, errors, handleChange }} />
                        <InputField label={'قیمت'} id={6} max_width={'49%'} name={'price'} type={'number'} {...{ data, touch, errors, handleChange }} />
                        <InputField label={'عرض'} id={7} max_width={'49%'} name={'width'} type={'number'} {...{ data, touch, errors, handleChange }} />
                        <InputField label={'عرض پیکسلی'} id={8} max_width={'49%'} name={'pixel_width'} type={'number'} {...{ data, touch, errors, handleChange }} />
                        <InputField label={'ترتیب'} id={9} max_width={'49%'} name={'category'} type={'number'} {...{ data, touch, errors, handleChange }} />
                        <div className="relative pb-6 mb-4 max-w-[100%] w-full">
                            <div className="w-full relative">
                                <textarea rows="5" name='body' value={data.body} onChange={handleChange}
                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer"
                                    placeholder="توضیحات"
                                />
                                <span className="absolute -top-6 left-3">{data.body?.length}</span>
                            </div>
                            {touch.body && errors.body && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors.body}</p>}
                        </div>
                    </div>
                    <button disabled={loading} className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                     focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ">{loading ?
                            <div role="status">
                                <svg stroke="currentColor" aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin fill-gray-50" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                            : 'ثبت'}</button>
                </form >
            </div >
        </>
    );
};

export default NewFrame;